import { Alert, Collapse } from '@mui/material';
import { AppGlobalAlertContext } from 'app/providers';
import config from 'config/config';
import React, { FC, useContext } from 'react';
import { useStyles } from './AppGlobalAlert.styles';

export const AppGlobalAlert: FC = () => {
  const { classes } = useStyles();
  const { open, setOpen } = useContext(AppGlobalAlertContext);

  return (
    <Collapse in={open}>
      <Alert
        variant="filled"
        severity="warning"
        className={classes.root}
        onClose={() => setOpen(false)}
      >
        {config.globalAlertMessage}
      </Alert>
    </Collapse>
  );
};
